<!--
     <IndicatorTracking
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
   - value
   - size
   - label
   - required
   - readonly
   - class
   - disabled
   - compact
   - metrics (required)
-->

<template>
  <div class="imt-cont">
    <header class="imt">
      <h1 class="imt">{{ props.label }}</h1>
    </header>

    <div :class="'imt-list' + (props.compact ? ' compact' : '')">
      <div
        class="imt-metric"
        v-for="(mt, index) in editable_metrics"
        :key="mt.id"
      >
        <div class="imt-infobox">
          <div class="imt-metric-name">{{ mt.name }}</div>
          <div class="imt-metric-description">{{ mt.description }}</div>
        </div>

        <div class="imt-inputcont">
          <component
            v-bind:is="mt.type == 'category' ? 'InputMetricCategory' : 'InputMetricNumber'"
            :initial_value="(props.value || {})[mt.id]"
            :metric_config="mt.metric_config"
            :readonly="props.readonly || props.disabled"
            :required="props.required"
            :label="mt.name"
            @change="(value) => update_value(mt.id, value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
 @import '@/sass/modalform.scss';
 @import "@/sass/variables.scss";

 .imt-cont {
   width: 100%;
   /* border-style: solid;
      border-width: 1px;
      border-color: $primary;
      border-radius: 5px; */
   display: flex;
   flex-direction: column;
   padding: 8px;
   gap: 10px;
 }

 header.imt {
   display: flex;
   flex-direction: row;
   width: 100%;
 }

 h1.imt {
   color: #444;
   font-size: 1.2em;
   font-weight: normal;
 }

 .imt-list {
   display: flex;
   flex-direction: column;
   gap: 10px;
 }

 .imt-metric {
   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   gap: 24px;
   padding: 8px;
   align-items: center;
   justify-content: space-between;
 }

 .imt-infobox {
   width: 40%;
   min-width: 320px;
   max-width: 640px;
   display: flex;
   flex-direction: column;
   gap: 12px;
   min-width: 240px;
 }

 .imt-metric-name {
   color: #444;
   font-size: 16px;
   /* font-weight: bold; */
 }

 .imt-metric-description {
   color: #444;
   font-size: 1em;
 }

 .imt-inputcont {
   width: 1%;
   flex-grow: 6;
   min-width: 160px;
   max-width: 80vw;
 }

 .imt-list.compact {
   flex-direction: row;
   flex-wrap: wrap;
 }

 .imt-list.compact > .imt-metric {
   max-width: 320px;
 }
 
 .imt-list.compact > .imt-metric > .imt-infobox {
   display: none;
 }

 .imt-list.compact > .imt-metric > .imt-inputcont {
   max-width: 320px;
 }
</style>

<script>
 import InputMetricNumber from '@/components/indicator/InputMetricNumber';
 import InputMetricCategory from '@/components/indicator/InputMetricCategory';
 import { TYPES_NAMES } from '@/utils/indicator.js';

 export default {
   name: 'IndicatorTrackingInput',

   props: ['props', 'required_rule'],

   components: {
     InputMetricNumber,
     InputMetricCategory,
   },

   data: () => ({
     valid: true,
     metrics: [],
     values: {},
   }),

   mounted() {
     this.pull_from_value(this.props.value);
     this.pull_from_metrics(this.props.metrics);
   },

   computed: {
     value() {
       return this.serialize();
     },

     editable_metrics() {
       return this.metrics.filter(
         mt => (mt.type == 'number' || mt.type == 'category')
       );
     },

     metric_edit_modal() {
       return this.$refs.metric_edit_modal;
     }
   },

   methods: {
     validate() {
       return true; // TODO
     },

     pull_from_value(val) {
       this.values = {...(val || {})};
     },

     pull_from_metrics(mets) {
       this.metrics = Array.from(mets || []);
       this.metrics.sort((a, b) => a.id - b.id);
     },

     update_value(mid, value) {
       this.values[mid] = value;
       this.update(this.serialize());
     },

     serialize() {
       return {...this.values};
     },

     is_required(value) {
       // TODO: Multilang: Change hardcoded string
       return !!value || !this.props.required || this.$vuetify.lang.translator('required_field');
     },

     error_state(ok) {
       this.valid = ok;
     },

     update(value) {
       this.$emit('update', value);
     },
   },

   watch: {
     props: {
       deep: true,
       value(val) {
         this.pull_from_value(val);
       },

       metrics(met) {
         this.pull_from_metrics(met);
       },

       handler() {
         // Other property changes get ignored
       },
     },
   },
 }
</script>
